var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThinkingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.16659 20.1668H12.8333M7.33325 13.7502H14.6666M4.58325 8.25016C4.58325 6.54836 5.25929 4.91625 6.46265 3.71289C7.66601 2.50954 9.29812 1.8335 10.9999 1.8335C12.7017 1.8335 14.3338 2.50954 15.5372 3.71289C16.7405 4.91625 17.4166 6.54836 17.4166 8.25016C17.4173 9.28334 17.1675 10.3013 16.6886 11.2167C16.2096 12.1322 15.5158 12.9178 14.6666 13.5063L14.1698 15.8585C14.104 16.2921 13.885 16.6877 13.5525 16.9736C13.22 17.2595 12.796 17.4167 12.3575 17.4168H9.64234C9.20382 17.4167 8.77986 17.2595 8.44736 16.9736C8.11487 16.6877 7.89586 16.2921 7.83009 15.8585L7.33325 13.5164C6.48377 12.9258 5.78992 12.1384 5.31102 11.2213C4.83212 10.3042 4.58242 9.28476 4.58325 8.25016Z",
    stroke: "#717182",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThinkingIcon);
export default __webpack_public_path__ + "static/media/thinking-icon.b831b70e0ad212b296e008b1f2d9314d.svg";
export { ForwardRef as ReactComponent };